<footer class="site-footer">
  <div class="footer-inner">
   

    <div class="footer-row">
      <div class="footer-links center-links">
        <a routerLink="/privacy-policy">Privacy Policy</a>
      </div>
      <p class="footer-copyright">Copyright © 2025 - 2026 Avecsage, Inc. All rights reserved.</p>
    </div>
  </div>
</footer>
